/** Заголовок сторінки списку: підпис пункту меню або, для подань без фільтра пункту меню, підпис подання. */
import { isCustomView } from './isCustomView';

/**
 * Чи подання вантажить дані само, без сторінки списку: власні подання пакета (аналітика) і панель показників — вони беруть відбір списку
 * з model.query; для них заголовок «Мої завдання» чи «Призначені мені» описував би не те, що на екрані. Календар — звичайне подання
 * списку (увесь відфільтрований список за датами). Чиста функція.
 */
export function ignoresMenuFilter(view: string): boolean {
  return isCustomView(view) || view === 'dashboard';
}

/** Заголовок сторінки списку: для подання без фільтра пункту меню — підпис подання (як на вкладці перемикача), інакше — пункту меню. */
export function listHeading(view: string, entryLabel: string, viewLabel: (view: string) => string): string {
  return ignoresMenuFilter(view) ? viewLabel(view) : entryLabel;
}
